module.exports = "https://web-assets.ifttt.com/packs/media/header/logo-maker-889a0c62.svg";